export const GLOBAL_SETTINGS = {
  opportunity: {
    truncate: {
      name: 20,
      professionalTitle: 50
    }
  } 
}
